// extracted by mini-css-extract-plugin
module.exports = {"container":"MapInfoWindow__container","image":"MapInfoWindow__image","detail":"MapInfoWindow__detail","space":"MapInfoWindow__space"};